import { getRequest } from 'services/apiRequests';
import { OpenAPIJobResponse, StringifiedUUID } from 'types';

const apiUrl = '/api/v1/job-aggregations/';
const jobsApiUrl = '/api/v1/jobs/';

type JobsAggregationQueryJobDataDetailsType = {
  download_id?: string;
  download_url?: string;
  /** Present when job is create-scenario success; used for banner redirect to new scenario */
  scenario_uuid?: string;
  planning_cycle_uuid?: string;
  success_message?: string;
};

export enum JobsAggregationStatus {
  SUCCESS = 'SUCCESS',
  FAILURE = 'FAILURE',
  PENDING = 'PENDING',
  STARTED = 'STARTED',
}

export type JobsAggregationQueryJobDataType = {
  status: JobsAggregationStatus;
  details: JobsAggregationQueryJobDataDetailsType;
  url: string;
};

export type JobsAggregationQueryType = {
  status: JobsAggregationStatus;
  data: Array<JobsAggregationQueryJobDataType>;
};

const getJobsAggregationQuery = (jobId: StringifiedUUID) => {
  return getRequest<null, JobsAggregationQueryType>(`${apiUrl}${jobId}/?include_tasks=true`);
};

const getJobById = (jobId: StringifiedUUID) => {
  return getRequest<null, OpenAPIJobResponse>(`${jobsApiUrl}${jobId}/`);
};

export const JobsService = {
  getJobById,
  getJobsAggregationQuery,
};
